import React, { useState } from 'react';
import { Select, Typography, Row, Col, Card } from 'antd';

const { Text, Title } = Typography;
const { Option } = Select;

const mockData = [
    { symbol: 'BTC', name: 'Bitcoin', description: 'Digital gold', url: 'https://bitcoin.org', image: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png' },
    { symbol: 'ETH', name: 'Ethereum', description: 'Smart contract platform', url: 'https://ethereum.org', image: 'https://cryptologos.cc/logos/ethereum-eth-logo.png' },
    { symbol: 'USDT', name: 'Tether', description: 'Stablecoin', url: 'https://tether.to', image: 'https://cryptologos.cc/logos/tether-usdt-logo.png' },
    { symbol: 'BNB', name: 'Binance Coin', description: 'Binance exchange token', url: 'https://www.binance.com', image: 'https://cryptologos.cc/logos/binance-coin-bnb-logo.png' },
    { symbol: 'USDC', name: 'USD Coin', description: 'Stablecoin', url: 'https://www.circle.com/en/usdc', image: 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png' },
    { symbol: 'SOL', name: 'Solana', description: 'High-performance blockchain', url: 'https://solana.com', image: 'https://cryptologos.cc/logos/solana-sol-logo.png' },
    { symbol: 'ADA', name: 'Cardano', description: 'Proof-of-stake blockchain', url: 'https://cardano.org', image: 'https://cryptologos.cc/logos/cardano-ada-logo.png' },
    { symbol: 'DOGE', name: 'Dogecoin', description: 'Meme cryptocurrency', url: 'https://dogecoin.com', image: 'https://cryptologos.cc/logos/dogecoin-doge-logo.png' },
    { symbol: 'XRP', name: 'XRP', description: 'Cross-border payments', url: 'https://ripple.com', image: 'https://cryptologos.cc/logos/xrp-xrp-logo.png' },
    { symbol: 'DOT', name: 'Polkadot', description: 'Interoperability-focused blockchain', url: 'https://polkadot.network', image: 'https://cryptologos.cc/logos/polkadot-dot-logo.png' },
    { symbol: 'AVAX', name: 'Avalanche', description: 'Scalable smart contracts platform', url: 'https://www.avax.network', image: 'https://cryptologos.cc/logos/avalanche-avax-logo.png' },
    { symbol: 'SHIB', name: 'Shiba Inu', description: 'Meme cryptocurrency', url: 'https://shibatoken.com', image: 'https://cryptologos.cc/logos/shiba-inu-shib-logo.png' },
    { symbol: 'MATIC', name: 'Polygon', description: 'Ethereum scaling solution', url: 'https://polygon.technology', image: 'https://cryptologos.cc/logos/polygon-matic-logo.png' },
    { symbol: 'LINK', name: 'Chainlink', description: 'Decentralized oracle network', url: 'https://chain.link', image: 'https://cryptologos.cc/logos/chainlink-link-logo.png' },
    { symbol: 'LTC', name: 'Litecoin', description: 'Peer-to-peer digital currency', url: 'https://litecoin.org', image: 'https://cryptologos.cc/logos/litecoin-ltc-logo.png' },
    { symbol: 'BUSD', name: 'Binance USD', description: 'Stablecoin', url: 'https://www.binance.com/en/busd', image: 'https://cryptologos.cc/logos/binance-usd-busd-logo.png' },
    { symbol: 'TRX', name: 'TRON', description: 'Decentralized internet platform', url: 'https://tron.network', image: 'https://cryptologos.cc/logos/tron-trx-logo.png' },
    { symbol: 'XLM', name: 'Stellar', description: 'Cross-border payments', url: 'https://www.stellar.org', image: 'https://cryptologos.cc/logos/stellar-xlm-logo.png' },
    { symbol: 'BCH', name: 'Bitcoin Cash', description: 'Bitcoin fork', url: 'https://www.bitcoincash.org', image: 'https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png' },
    { symbol: 'ETC', name: 'Ethereum Classic', description: 'Ethereum fork', url: 'https://ethereumclassic.org', image: 'https://cryptologos.cc/logos/ethereum-classic-etc-logo.png' },
];

const News = () => {
    const [selectedSymbols, setSelectedSymbols] = useState(['BTC', 'ETH', 'USDT', 'BNB', 'USDC']);
    const [showDescription, setShowDescription] = useState(false);

    const data = mockData.filter((coin) => selectedSymbols.includes(coin.symbol)).slice(0, 9);

    return (
        <div style={{ backgroundColor: '#121212', color: 'white', padding: '20px' }}>
            <Title level={2} style={{ color: 'red' }}>Latest Cryptocurrency News</Title>
            <Select
                mode="multiple"
                showSearch
                className="select-symbols"
                placeholder="Select Symbols"
                optionFilterProp="children"
                onChange={(values) => setSelectedSymbols(values)}
                filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                style={{ marginBottom: '20px', width: '100%' }}
            >
                {mockData.map((coin) => (
                    <Option key={coin.symbol} value={coin.symbol}>
                        <img src={coin.image} alt={coin.name} style={{ width: '20px', marginRight: '10px' }} />
                        {coin.name} ({coin.symbol})
                    </Option>
                ))}
            </Select>
            <button onClick={() => setShowDescription(!showDescription)} style={{ marginBottom: '20px', backgroundColor: 'red', color: 'white', border: 'none', padding: '10px', cursor: 'pointer' }}>
                {showDescription ? 'Hide Descriptions' : 'Show Descriptions'}
            </button>
            <Row gutter={[24, 24]}>
                {data.map((coin) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={coin.symbol}>
                        <Card hoverable className="news-card" style={{ backgroundColor: '#1f1f1f', border: '1px solid red' }}>
                            <a href={coin.url} target="_blank" rel="noreferrer">
                                <img src={coin.image} alt={coin.name} style={{ width: '64px', marginBottom: '10px' }} />
                                <Title level={4} style={{ color: 'white' }}>{coin.name} ({coin.symbol})</Title>
                                {showDescription && <Text style={{ color: 'white' }}>{coin.description}</Text>}
                            </a>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default News;
